export default "__VITE_ASSET__bcf8f9d5__"